module.exports = __webpack_public_path__ + "static/img/SLAB_MAPLE.9119509.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SLAB_MAPLE.jpg
// module id = aeFy
// module chunks = 0